export const MODAL_ACTION_TYPES = {
  SET_MODAL: "SET_MODAL",
};
